/**
 * Alarm kural KATALOĞU (Prompt 20, ADR 0020 §2) — tek doğru; `docs/domain/alarms.md` §2 tablosu bununla aynı tutulur.
 * Kiracı / istasyon yalnızca GEÇERSİZ KILAR (`alarm_rules`: etkin, önem, eşikler, yükseltme dakikası). Modülün kendi eşiği varsa
 * (tank asgarileri, mutabakat eşikleri, vardiya toleransı, lisans uyarı günü…) motor ONU okur; buradaki `thresholds` yalnızca
 * kendi eşiği olmayan kurallar içindir.
 *
 * Şablonlar Türkçe; `{param}` yer tutucuları motorun sinyal parametreleridir (kişisel veri YOK). BAŞLIK KURALI: istasyon
 * kapsamlı alarm "{stationCode} · …" ile başlar; aynı kuralın farklı varlık / gün alarmları başlıktan ayırt edilir (tank,
 * tabanca, ürün, ünite, belge no, iş günü…); başlıkta makine kodu (BÜYÜK_HARF_ALT_ÇİZGİ) yer almaz — kod / hata iletide.
 *
 * `link` web yolu kalıbıdır ve hedef ekranın OKUDUĞU arama parametrelerini taşır (`docs/domain/alarms.md` §2 "Bağlantılar"):
 * istasyon `?station=`, şirket `company=` (şirket seçicili ekranlarda; seçili şirket başkaysa istasyon bulunamazdı). Motor
 * bağlantıyı alarmın `stationId` / `companyId` / `entityId` + sinyal parametreleriyle doldurur; eksik sorgu parametresi düşer.
 */
export const ALARM_RULE_CODES = [
    "TANK_LOW_LEVEL",
    "TANK_OVERFILL_RISK",
    "RECON_VARIANCE",
    "IDLE_LEVEL_DROP",
    "WATER_RISE",
    "DELIVERY_VARIANCE",
    "PRICE_MISMATCH",
    "TOTALIZER_ANOMALY",
    "AGENT_OFFLINE",
    "AGENT_SYNC_GAP",
    "DEVICE_FAULT",
    "SHIFT_CASH_DIFFERENCE",
    "CASH_COUNT_DIFFERENCE",
    "Z_REPORT_MISMATCH",
    "SHIFT_OPEN_TOO_LONG",
    "DAY_UNCLOSED",
    "CHEQUE_COLLECTION_DUE",
    "OWN_CHEQUE_DUE",
    "CHEQUE_BOUNCED",
    "POS_SETTLEMENT_OVERDUE",
    "TREASURY_DUE",
    "INCOMING_INVOICE_DEADLINE",
    "EDOCUMENT_FAILED",
    "CREDIT_LIMIT_EXCEEDED",
    "CASH_SHORTFALL",
    "DOCUMENT_EXPIRY",
    "SALES_DROP",
    "POSTING_EXCEPTION",
    "LOYALTY_ABUSE",
    "FLEET_RULE_VIOLATION",
    "DOUBLE_REDEMPTION",
    "STOCK_EXPIRY",
    "STOCK_NEGATIVE",
    "PRIVACY_REQUEST_DUE",
    "BUDGET_VARIANCE",
    "TAX_OBLIGATION_DUE",
    "MAINTENANCE_SLA_BREACH",
    "CORRECTIVE_ACTION_DUE",
];
const STATION_OPS = ["STATION_MANAGER"];
const STATION_OPS_WITH_CASHIER = ["STATION_MANAGER", "CASHIER"];
const FINANCE = ["ACCOUNTANT"];
export const ALARM_RULES = {
    TANK_LOW_LEVEL: {
        code: "TANK_LOW_LEVEL",
        category: "FUEL",
        label: "Tank seviyesi düşük / kritik",
        description: "Son tank okuması tankın asgari seviyesinin (önemli) ya da kritik seviyesinin (kritik) altında. Seviye asgari + %5'e çıkınca kendiliğinden çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "CHECK",
        events: [],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 15,
        thresholds: { recoveryBufferPercent: 5 },
        dedupPattern: "TANK_LOW_LEVEL:tank:{tankId}",
        link: "/akaryakit/tanklar?station={stationId}&tank={tankId}&company={companyId}",
        titleTemplate: "{stationCode} · {tankName} seviyesi {levelLabel}",
        messageTemplate: "{tankName} ({productName}) {volumeL} L; asgari {minLevelL} L, kritik {criticalLevelL} L.",
    },
    TANK_OVERFILL_RISK: {
        code: "TANK_OVERFILL_RISK",
        category: "FUEL",
        label: "Tank taşma riski",
        description: "Son tank okuması güvenli doluluk oranının üstünde. Seviye güvenli doluluğun %2 altına inince çözülür.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "CHECK",
        events: [],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS_WITH_CASHIER,
        escalationMinutes: 15,
        thresholds: { recoveryBufferPercent: 2 },
        dedupPattern: "TANK_OVERFILL_RISK:tank:{tankId}",
        link: "/akaryakit/tanklar?station={stationId}&tank={tankId}&company={companyId}",
        titleTemplate: "{stationCode} · {tankName} taşma riski",
        messageTemplate: "{tankName} doluluk %{fillPercent} (güvenli sınır %{safeFillPercent}).",
    },
    RECON_VARIANCE: {
        code: "RECON_VARIANCE",
        category: "FUEL",
        label: "Islak stok farkı (şüpheli / kritik)",
        description: "Günlük tank mutabakatı şüpheli ya da kritik sınıflandı. Mutabakat onaylanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT",
        events: ["fuel.reconciliation.classified"],
        resolveEvents: ["fuel.reconciliation.approved"],
        resolvedByCheck: false,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 30,
        thresholds: {},
        dedupPattern: "RECON_VARIANCE:recon:{tankId}:{businessDate}",
        link: "/akaryakit/mutabakat?station={stationId}&tank={tankId}&row={reconciliationId}&company={companyId}",
        titleTemplate: "{stationCode} · {tankName} ıslak stok farkı ({classificationLabel}) · {businessDate}",
        messageTemplate: "{businessDate} farkı {varianceL} L (%{variancePercent}); birikimli {cumulativeVarianceL} L.",
    },
    IDLE_LEVEL_DROP: {
        code: "IDLE_LEVEL_DROP",
        category: "FUEL",
        label: "Satışsız seviye düşüşü (gece / sızıntı şüphesi)",
        description: "Satış yokken tank seviyesi saatlik eşiğin üstünde düştü. Mutabakat onaylanınca çözülür.",
        defaultSeverity: "CRITICAL",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT",
        events: ["fuel.reconciliation.classified"],
        resolveEvents: ["fuel.reconciliation.approved"],
        resolvedByCheck: false,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 15,
        thresholds: {},
        dedupPattern: "IDLE_LEVEL_DROP:tank:{tankId}:{businessDate}",
        link: "/akaryakit/mutabakat?station={stationId}&tank={tankId}&row={reconciliationId}&company={companyId}",
        titleTemplate: "{stationCode} · {tankName} satışsız seviye düşüşü · {businessDate}",
        messageTemplate: "{businessDate} satışsız saatlerde {measured} L/saat düşüş (eşik {threshold}).",
    },
    WATER_RISE: {
        code: "WATER_RISE",
        category: "FUEL",
        label: "Tank suyu artışı",
        description: "Tank dibindeki su seviyesi eşiğin üstünde arttı. Mutabakat onaylanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT",
        events: ["fuel.reconciliation.classified"],
        resolveEvents: ["fuel.reconciliation.approved"],
        resolvedByCheck: false,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 30,
        thresholds: {},
        dedupPattern: "WATER_RISE:tank:{tankId}:{businessDate}",
        link: "/akaryakit/mutabakat?station={stationId}&tank={tankId}&row={reconciliationId}&company={companyId}",
        titleTemplate: "{stationCode} · {tankName} su seviyesi arttı · {businessDate}",
        messageTemplate: "{businessDate} su artışı {measured} mm (eşik {threshold} mm).",
    },
    DELIVERY_VARIANCE: {
        code: "DELIVERY_VARIANCE",
        category: "FUEL",
        label: "Dolum (tanker boşaltma) farkı",
        description: "Tanker boşaltmasında ölçülen miktar irsaliyeden tolerans dışında farklı.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["fuel.delivery.variance_exceeded", "fuel.delivery.confirmed"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "DELIVERY_VARIANCE:delivery:{deliveryId}",
        link: "/akaryakit/dolumlar/{deliveryId}",
        titleTemplate: "{stationCode} · {deliveryNo} dolum farkı",
        messageTemplate: "Toplam fark {differenceL} L (tolerans {toleranceL} L).",
    },
    PRICE_MISMATCH: {
        code: "PRICE_MISMATCH",
        category: "FUEL",
        label: "Fiyat uyumsuzluğu",
        description: "Pompada eski fiyatla satış yapıldı ya da fiyat güncelleme komutu pompalara ulaşmadı. İstasyonda başarılı fiyat güncellemesi gelince çözülür.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "EVENT",
        events: ["fuel.price.stale_sale_detected", "agents.command.price_update_failed"],
        resolveEvents: ["agents.command.finished"],
        resolvedByCheck: false,
        permission: "fuel.price.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 15,
        thresholds: {},
        dedupPattern: "PRICE_MISMATCH:{stationId}:{entityId}",
        link: "/fiyatlar",
        titleTemplate: "{stationCode} · fiyat uyumsuzluğu",
        messageTemplate: "{detail}",
    },
    TOTALIZER_ANOMALY: {
        code: "TOTALIZER_ANOMALY",
        category: "FUEL",
        label: "Endeks – işlem tutarsızlığı",
        description: "Tabanca endeksi geriye gitti ya da beklenmedik sıçradı.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["fuel.totalizer.anomaly_detected"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "fuel.ops.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "TOTALIZER_ANOMALY:nozzle:{nozzleId}:{businessDate}",
        link: "/akaryakit/endeks?station={stationId}&nozzle={nozzleId}&company={companyId}",
        titleTemplate: "{stationCode} · {nozzleLabel} endeks tutarsızlığı · {businessDate}",
        messageTemplate: "{reasonLabel}: önceki {previousL} L → şimdiki {currentL} L ({businessDate}).",
    },
    AGENT_OFFLINE: {
        code: "AGENT_OFFLINE",
        category: "DEVICE",
        label: "İstasyon ajanı çevrimdışı",
        description: "İstasyon ajanından belirlenen süredir sinyal gelmiyor. Ajan yeniden bağlanınca çözülür.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "EVENT",
        events: ["agents.agent.offline"],
        resolveEvents: ["agents.agent.online"],
        resolvedByCheck: false,
        permission: "agents.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 15,
        thresholds: {},
        dedupPattern: "AGENT_OFFLINE:agent:{agentId}",
        link: "/ajanlar/{agentId}",
        titleTemplate: "{stationCode} · istasyon ajanı çevrimdışı",
        messageTemplate: "{hostname} son görülme {lastSeenAt}.",
    },
    AGENT_SYNC_GAP: {
        code: "AGENT_SYNC_GAP",
        category: "DEVICE",
        label: "Ajan verisinde kurtarılamayan boşluk",
        description: "Sunucu yedekten geri döndükten sonra ajanın yerel saklama süresini aşan olaylar (satış, okuma, Z raporu…) yeniden " +
            "gönderilemedi; bu sıra aralığı sunucuda yok. Aralığın verisi elle denetlenip tamamlanır, sonra alarm kapatılır.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "EVENT",
        events: ["agents.sync.gap_skipped"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "agents.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: 60,
        thresholds: {},
        dedupPattern: "AGENT_SYNC_GAP:agent:{agentId}:{fromSeq}",
        link: "/ajanlar/{agentId}",
        titleTemplate: "{stationCode} · ajan verisinde kurtarılamayan boşluk",
        messageTemplate: "{fromSeq}–{toSeq} sıra aralığındaki {lostCount} olay sunucuya ulaşmadı (sunucu geri yükleme sonrası).",
    },
    DEVICE_FAULT: {
        code: "DEVICE_FAULT",
        category: "DEVICE",
        label: "Cihaz arızası (pompa, prob, ÖKC, yıkama, şarj)",
        description: "İstasyon cihazı arıza bildirdi ya da bağlantısı koptu. Cihaz düzelince / yeniden bağlanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT_AND_CHECK",
        events: [
            "agents.device.alarm_raised",
            "wash.unit.fault_started",
            "ev.charger.fault_started",
            "ev.charger.disconnected",
            "pos.sale.fiscal_skipped",
        ],
        resolveEvents: ["wash.unit.fault_cleared", "ev.charger.fault_cleared", "ev.charger.connected"],
        resolvedByCheck: true,
        permission: "stations.read",
        defaultRoles: STATION_OPS_WITH_CASHIER,
        escalationMinutes: 30,
        thresholds: {},
        dedupPattern: "DEVICE_FAULT:{deviceKind}:{deviceKey}",
        link: "{deviceLink}",
        titleTemplate: "{stationCode} · {deviceLabel} arızası",
        messageTemplate: "{detail}",
    },
    SHIFT_CASH_DIFFERENCE: {
        code: "SHIFT_CASH_DIFFERENCE",
        category: "SHIFT",
        label: "Vardiya kasa farkı eşik üstü",
        description: "Kasiyer hesabında fark toleransı aştı. Hesap kabul edilince çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["shifts.closing.difference_exceeded"],
        resolveEvents: ["shifts.closing.accepted"],
        resolvedByCheck: false,
        permission: "shifts.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "SHIFT_CASH_DIFFERENCE:closing:{closingId}",
        link: "/vardiya/vardiyalar/{shiftId}",
        titleTemplate: "{stationCode} · {shiftNo} kasa farkı {difference}",
        messageTemplate: "Beklenen {expectedAmount}, fark {difference} (tolerans {toleranceLimit}).",
    },
    CASH_COUNT_DIFFERENCE: {
        code: "CASH_COUNT_DIFFERENCE",
        category: "FINANCE",
        label: "Kasa sayım farkı",
        description: "Kasa sayımında fark çıktı. Sayım karara bağlanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["treasury.cash_count.difference_detected"],
        resolveEvents: ["treasury.cash_count.decided"],
        resolvedByCheck: false,
        permission: "treasury.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "CASH_COUNT_DIFFERENCE:count:{countId}",
        link: "/finans/kasalar?company={companyId}",
        titleTemplate: "{stationCode} · {cashRegisterName} sayım farkı {difference}",
        messageTemplate: "{cashRegisterName} sayımında fark {difference}.",
    },
    Z_REPORT_MISMATCH: {
        code: "Z_REPORT_MISMATCH",
        category: "SHIFT",
        label: "Z raporu farkı",
        description: "ÖKC Z raporu toplamı sistem satışlarından eşik üstünde farklı. Fark kapatılınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT_AND_CHECK",
        events: ["shifts.z_report.mismatch"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "shifts.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "Z_REPORT_MISMATCH:z:{zReportId}",
        link: "/vardiya/z-raporlari?station={stationId}&company={companyId}",
        titleTemplate: "{stationCode} · Z raporu farkı {difference} · {businessDate}",
        messageTemplate: "{businessDate}: Z toplamı {zTotal}, sistem {systemAmount} (eşik {threshold}).",
    },
    SHIFT_OPEN_TOO_LONG: {
        code: "SHIFT_OPEN_TOO_LONG",
        category: "SHIFT",
        label: "Vardiya uzun süredir açık",
        description: "Vardiya ayardaki süreden uzun süredir açık. Vardiya kapanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["shifts.shift.open_too_long"],
        resolveEvents: ["shifts.shift.closed", "shifts.shift.cancelled"],
        resolvedByCheck: false,
        permission: "shifts.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "SHIFT_OPEN_TOO_LONG:shift:{shiftId}",
        link: "/vardiya/vardiyalar/{shiftId}",
        titleTemplate: "{stationCode} · {shiftNo} {openHours} saattir açık",
        messageTemplate: "Vardiya {openedAt} tarihinden beri açık.",
    },
    DAY_UNCLOSED: {
        code: "DAY_UNCLOSED",
        category: "SHIFT",
        label: "Gün sonu yapılmadı",
        description: "İş günü vardiyaları onaylandığı halde gün sonu kapatılmadı. Gün kapanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["shifts.day.unclosed"],
        resolveEvents: ["shifts.day.closed"],
        resolvedByCheck: false,
        permission: "shifts.read",
        defaultRoles: [...STATION_OPS, "ACCOUNTANT"],
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "DAY_UNCLOSED:{stationId}:{businessDate}",
        link: "/vardiya/gun-sonu?station={stationId}&date={businessDateIso}&company={companyId}",
        titleTemplate: "{stationCode} · {businessDate} gün sonu bekliyor",
        messageTemplate: "{businessDate} iş gününün gün sonu yapılmadı.",
    },
    CHEQUE_COLLECTION_DUE: {
        code: "CHEQUE_COLLECTION_DUE",
        category: "FINANCE",
        label: "Tahsil çeki vadesi yaklaşıyor",
        description: "Portföydeki müşteri çekinin vadesi yaklaşıyor. Çek işlem görünce çözülür.",
        defaultSeverity: "INFO",
        severities: ["INFO"],
        source: "EVENT",
        events: ["instruments.reminder.due"],
        resolveEvents: ["instruments.batch.posted"],
        resolvedByCheck: false,
        permission: "cheques.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "CHEQUE_COLLECTION_DUE:instrument:{instrumentId}",
        link: "/cek-senet/takvim?company={companyId}",
        titleTemplate: "Tahsil çeki vadesi {dueDate} · {amount}",
        messageTemplate: "{amount} tutarlı çekin vadesi {dueDate} ({dueIn}).",
    },
    OWN_CHEQUE_DUE: {
        code: "OWN_CHEQUE_DUE",
        category: "FINANCE",
        label: "Kendi çekimizin ödemesi (bakiye yetersizse kritik)",
        description: "Kendi çekimizin / senedimizin vadesi yaklaşıyor; bağlı banka hesabının bakiyesi yetersizse kritik. Çek işlem görünce çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["INFO", "IMPORTANT", "CRITICAL"],
        source: "EVENT",
        events: ["instruments.reminder.due"],
        resolveEvents: ["instruments.batch.posted"],
        resolvedByCheck: false,
        permission: "cheques.read",
        defaultRoles: [...FINANCE, "ADMIN"],
        escalationMinutes: 60,
        thresholds: {},
        dedupPattern: "OWN_CHEQUE_DUE:instrument:{instrumentId}",
        link: "/cek-senet/takvim?company={companyId}",
        titleTemplate: "Ödenecek çek {dueDate} · {amount}{balanceNote}",
        messageTemplate: "{amount} tutarlı çekin vadesi {dueDate} ({dueIn}).{balanceSentence}",
    },
    CHEQUE_BOUNCED: {
        code: "CHEQUE_BOUNCED",
        category: "FINANCE",
        label: "Karşılıksız çek",
        description: "Portföydeki çek karşılıksız döndü.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "EVENT",
        events: ["instruments.instrument.bounced"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "cheques.read",
        defaultRoles: [...FINANCE, "ADMIN"],
        escalationMinutes: 60,
        thresholds: {},
        dedupPattern: "CHEQUE_BOUNCED:instrument:{instrumentId}",
        link: "/cek-senet/{instrumentId}?company={companyId}",
        titleTemplate: "Karşılıksız çek {amount} · vade {dueDate}",
        messageTemplate: "{counterpartyName} çeki karşılıksız döndü (vade {dueDate}).",
    },
    POS_SETTLEMENT_OVERDUE: {
        code: "POS_SETTLEMENT_OVERDUE",
        category: "FINANCE",
        label: "POS yatışı gecikti / uyuşmadı",
        description: "Banka POS partisi valör tarihinde hesaba geçmedi ya da tutar uyuşmadı. Parti yatınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT_AND_CHECK",
        events: ["treasury.reminder.due", "treasury.pos_settlement.mismatch"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "treasury.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "POS_SETTLEMENT_OVERDUE:batch:{batchId}",
        link: "/finans/pos?company={companyId}",
        titleTemplate: "POS yatışı gecikti ({targetDate}) · {amount}",
        messageTemplate: "{amount} tutarlı POS partisi {targetDate} tarihinde yatmadı ({dueIn}).",
    },
    TREASURY_DUE: {
        code: "TREASURY_DUE",
        category: "FINANCE",
        label: "Finans hatırlatmaları (DBS, kredi taksiti, teminat)",
        description: "DBS ödemesi, kredi taksiti ya da teminat vadesi yaklaşıyor.",
        defaultSeverity: "INFO",
        severities: ["INFO"],
        source: "EVENT",
        events: ["treasury.reminder.due"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "treasury.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "TREASURY_DUE:{kind}:{refId}:{targetDate}",
        link: "/finans",
        titleTemplate: "{kindLabel} · {targetDate} · {amount}",
        messageTemplate: "Tutar {amount}, vade {targetDate} ({dueIn}).",
    },
    INCOMING_INVOICE_DEADLINE: {
        code: "INCOMING_INVOICE_DEADLINE",
        category: "INVOICING",
        label: "Gelen faturada kabul / red son günü",
        description: "Ticari gelen faturaya cevap süresi doluyor. Cevap verilince çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT_AND_CHECK",
        events: ["invoicing.incoming.response_due"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "invoices.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "INCOMING_INVOICE_DEADLINE:incoming:{incomingInvoiceId}",
        link: "/faturalar/gelen-kutusu?company={companyId}",
        titleTemplate: "Gelen fatura {invoiceNo} · cevap son günü {responseDueDate}",
        messageTemplate: "{payableAmount} tutarlı gelen faturaya cevap son günü {responseDueDate} ({dueIn}).",
    },
    EDOCUMENT_FAILED: {
        code: "EDOCUMENT_FAILED",
        category: "INVOICING",
        label: "e-Belge gönderim hatası",
        description: "e-Fatura / e-Arşiv / e-İrsaliye gönderimi başarısız. Belge başarıyla iletilince çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["invoicing.edocument.failed"],
        resolveEvents: ["invoicing.edocument.status_changed"],
        resolvedByCheck: false,
        permission: "invoices.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "EDOCUMENT_FAILED:{documentKind}:{documentId}",
        link: "/faturalar?company={companyId}",
        titleTemplate: "{documentKindLabel} {documentNo} gönderilemedi",
        messageTemplate: "{documentKindLabel} {attempts}. denemede de gönderilemedi (hata kodu {errorCode}).",
    },
    CREDIT_LIMIT_EXCEEDED: {
        code: "CREDIT_LIMIT_EXCEEDED",
        category: "FINANCE",
        label: "Cari limit aşımı",
        description: "Veresiye / filo satışı carinin limitini aştı (çevrimdışı kasa ya da onaylı geçersiz kılma).",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["pos.credit_limit_exceeded_offline", "shifts.credit_sale.recorded"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "counterparty.limit.read",
        defaultRoles: [...FINANCE, "STATION_MANAGER"],
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "CREDIT_LIMIT_EXCEEDED:counterparty:{counterpartyId}:{day}",
        link: "/cari/risk?company={companyId}",
        titleTemplate: "{stationCode} · {counterpartyName} limit aşımı · {dayLabel}",
        messageTemplate: "Satış sonrası risk {riskAfter}, limit {creditLimit}.",
    },
    CASH_SHORTFALL: {
        code: "CASH_SHORTFALL",
        category: "FINANCE",
        label: "Nakit açığı öngörüsü",
        description: "Nakit akış projeksiyonu ufuk içinde açık gösteriyor. Günün taramasında açık çıkmazsa çözülür.",
        defaultSeverity: "CRITICAL",
        severities: ["CRITICAL"],
        source: "EVENT_AND_CHECK",
        events: ["cashflow.shortfall.projected"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "cashflow.read",
        defaultRoles: [...FINANCE, "ADMIN"],
        escalationMinutes: 120,
        thresholds: {},
        dedupPattern: "CASH_SHORTFALL:company:{companyId}",
        link: "/nakit-akis?company={companyId}",
        titleTemplate: "Nakit açığı öngörüsü ({firstShortfallDate})",
        messageTemplate: "İlk açık günü {firstShortfallDate}, en düşük kullanılabilir {lowestAvailable} ({shortfallDayCount} gün).",
    },
    DOCUMENT_EXPIRY: {
        code: "DOCUMENT_EXPIRY",
        category: "COMPLIANCE",
        label: "Lisans / muayene / belge süresi doluyor",
        description: "Uyum belgesi (türün hatırlatma günlerine göre), istasyon lisansı (EPDK, satış belgeleri), tabanca damgası, cihaz garantisi ya da teminat bitişi yaklaşıyor; geçtiyse kritik. Belge yenilenince / bitiş ileri alınınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT_AND_CHECK",
        events: ["market.license.expiring", "market.license.expired", "treasury.reminder.due"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "stations.read",
        defaultRoles: [...STATION_OPS, "ADMIN"],
        escalationMinutes: null,
        thresholds: { warningDays: 30 },
        dedupPattern: "DOCUMENT_EXPIRY:{documentKind}:{documentId}:{expiresOn}",
        link: "{documentLink}",
        titleTemplate: "{stationCode} · {documentLabel} {expiryLabel}",
        messageTemplate: "{documentLabel} bitiş tarihi {expiresOn}.",
    },
    SALES_DROP: {
        code: "SALES_DROP",
        category: "SALES",
        label: "Satışlarda olağandışı düşüş",
        description: "Bugünün o saate kadarki satışı son haftaların aynı gün / saat ortalamasının belirgin altında. Oran toparlanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "CHECK",
        events: [],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "fuel.ops.read",
        defaultRoles: [...STATION_OPS, "REGION_MANAGER"],
        escalationMinutes: null,
        thresholds: { dropPercent: 40, weeks: 4, minWeeks: 2, minBaselineAmount: 500_000, earliestHour: 10 },
        dedupPattern: "SALES_DROP:{stationId}:{day}",
        link: "/akaryakit/satislar?station={stationId}&day={day}&company={companyId}",
        titleTemplate: "{stationCode} · satışlar %{dropPercent} düşük · {dayLabel}",
        messageTemplate: "Saat {hour}:00'e kadar {actualAmount}; son {weeks} haftanın ortalaması {baselineAmount}.",
    },
    POSTING_EXCEPTION: {
        code: "POSTING_EXCEPTION",
        category: "ACCOUNTING",
        label: "Eşleştirme bekleyen muhasebe kaydı",
        description: "Kayıt anahtarının hesap eşleştirmesi olmadığı için fiş kesilemedi. İstisna çözülünce çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT_AND_CHECK",
        events: ["accounting.posting_exception.raised"],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "accounting.entry.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "POSTING_EXCEPTION:exception:{exceptionId}",
        link: "/muhasebe/eslestirmeler?company={companyId}",
        titleTemplate: "Eşleştirme bekleyen kayıt ({sourceLabel})",
        messageTemplate: "Eksik anahtarlar: {missingKeys}.",
    },
    LOYALTY_ABUSE: {
        code: "LOYALTY_ABUSE",
        category: "CUSTOMER",
        label: "Sadakat kötüye kullanım şüphesi",
        description: "Kısa sürede eşiği aşan puan kazanımı.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["loyalty.abuse_suspected"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "loyalty.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "LOYALTY_ABUSE:account:{accountId}:{day}",
        link: "/sadakat/inceleme",
        titleTemplate: "{stationCode} · sadakat kötüye kullanım şüphesi · {dayLabel}",
        messageTemplate: "{reasonLabel} ({points} puan incelemeye düştü).",
    },
    FLEET_RULE_VIOLATION: {
        code: "FLEET_RULE_VIOLATION",
        category: "CUSTOMER",
        label: "Filo kural ihlali",
        description: "Filo aracının satışı filo kuralını ihlal etti (onaylı ya da reddedilmiş).",
        defaultSeverity: "INFO",
        severities: ["INFO"],
        source: "EVENT",
        events: ["fleet.rule.violated"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "fleet.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "FLEET_RULE_VIOLATION:vehicle:{vehicleId}:{day}",
        link: "/filo/{counterpartyId}?vehicle={vehicleId}",
        titleTemplate: "{stationCode} · filo kural ihlali ({violationsLabel}) · {dayLabel}",
        messageTemplate: "{counterpartyName}: {violationsLabel}{overrideNote}; tutar {amount}.",
    },
    DOUBLE_REDEMPTION: {
        code: "DOUBLE_REDEMPTION",
        category: "CUSTOMER",
        label: "Çift kullanım / çift ödeme",
        description: "Kupon, abonelik hakkı, puan ya da şarj oturumu ikinci kez kullanıldı / ödendi (çoğunlukla çevrimdışı kasa); iade / düzeltme gerekir.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: [
            "loyalty.coupon.double_redemption",
            "ev.session.double_payment",
            "loyalty.points.overdrawn",
            "loyalty.subscription.overused",
            "wash.credit.negative_balance",
        ],
        resolveEvents: ["ev.session.payment_reverted"],
        resolvedByCheck: false,
        permission: "loyalty.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "DOUBLE_REDEMPTION:{sourceKind}:{sourceId}",
        link: "{sourceLink}",
        titleTemplate: "{stationCode} · {sourceLabel}",
        messageTemplate: "{detail}",
    },
    STOCK_EXPIRY: {
        code: "STOCK_EXPIRY",
        category: "STOCK",
        label: "Son kullanma tarihi (SKT)",
        description: "Stoktaki partinin SKT'si yaklaşıyor ya da geçti.",
        defaultSeverity: "INFO",
        severities: ["INFO", "IMPORTANT"],
        source: "EVENT",
        events: ["market.lot.expiring", "market.lot.expired"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "market.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "STOCK_EXPIRY:lot:{lotId}:{state}",
        link: "/market/partiler?station={stationId}&product={productId}&company={companyId}",
        titleTemplate: "{stationCode} · {productName} SKT {expiryLabel}{lotNote}",
        messageTemplate: "{productName} partisinin SKT'si {expiresOn}; stokta {quantity}.",
    },
    STOCK_NEGATIVE: {
        code: "STOCK_NEGATIVE",
        category: "STOCK",
        label: "Negatif stok",
        description: "Ürünün depo stoğu eksiye düştü (satış mal kabulden önce ya da sayım farkı).",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT"],
        source: "EVENT",
        events: ["market.stock.negative"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "market.read",
        defaultRoles: STATION_OPS,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "STOCK_NEGATIVE:{warehouseId}:{productId}",
        link: "/market/stok?station={stationId}&warehouse={warehouseId}&company={companyId}",
        titleTemplate: "{stationCode} · {productName} negatif stok",
        messageTemplate: "{productName} stoğu {quantity} ({warehouseName}).",
    },
    PRIVACY_REQUEST_DUE: {
        code: "PRIVACY_REQUEST_DUE",
        category: "PRIVACY",
        label: "KVKK başvuru süresi",
        description: "İlgili kişi başvurusunun yasal cevap süresi doluyor (önemli) ya da geçti (kritik). Başvuru tamamlanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "EVENT",
        events: ["privacy.request.due_soon", "privacy.request.overdue"],
        resolveEvents: ["privacy.request.completed"],
        resolvedByCheck: false,
        permission: "privacy.read",
        defaultRoles: ["ADMIN"],
        escalationMinutes: 240,
        thresholds: {},
        dedupPattern: "PRIVACY_REQUEST_DUE:request:{requestId}",
        link: "/kvkk/basvurular",
        titleTemplate: "KVKK başvurusu {requestNo} · son gün {dueDate}",
        messageTemplate: "Başvurunun cevap süresi {dueDate} ({dueIn}).",
    },
    BUDGET_VARIANCE: {
        code: "BUDGET_VARIANCE",
        category: "FINANCE",
        label: "Bütçe sapması",
        description: "Gerçekleşen, bütçenin eşik yüzdesini aştı.",
        defaultSeverity: "INFO",
        severities: ["INFO"],
        source: "EVENT",
        events: ["budget.variance.exceeded"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "budget.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "BUDGET_VARIANCE:budget:{budgetId}:{period}",
        link: "/butce?company={companyId}",
        titleTemplate: "Bütçe sapması · {budgetName} · {period}",
        messageTemplate: "{period}: sapma %{variancePercent}.",
    },
    TAX_OBLIGATION_DUE: {
        code: "TAX_OBLIGATION_DUE",
        category: "FINANCE",
        label: "Vergi / beyan son günü",
        description: "Vergi takvimindeki yükümlülüğün son günü yaklaşıyor.",
        defaultSeverity: "INFO",
        severities: ["INFO", "IMPORTANT"],
        source: "EVENT",
        events: ["taxcalendar.obligation.due"],
        resolveEvents: [],
        resolvedByCheck: false,
        permission: "taxcalendar.read",
        defaultRoles: FINANCE,
        escalationMinutes: null,
        thresholds: {},
        dedupPattern: "TAX_OBLIGATION_DUE:obligation:{obligationId}",
        link: "/vergi-takvimi?company={companyId}",
        titleTemplate: "{obligationName} · son gün {dueDate}",
        messageTemplate: "{obligationName} son günü {dueDate} ({dueIn}).",
    },
    MAINTENANCE_SLA_BREACH: {
        code: "MAINTENANCE_SLA_BREACH",
        category: "DEVICE",
        label: "Bakım iş emri SLA'sı aşıldı",
        description: "Açık bakım / arıza iş emrinin yanıt ya da çözüm son anı geçti (acil iş emrinde kritik). İş emri tamamlanınca / iptal edilince çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "CHECK",
        events: [],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "maintenance.read",
        defaultRoles: [...STATION_OPS, "REGION_MANAGER"],
        escalationMinutes: 240,
        thresholds: {},
        dedupPattern: "MAINTENANCE_SLA_BREACH:work_order:{workOrderId}:{slaKind}",
        link: "/bakim/is-emirleri/{workOrderId}",
        titleTemplate: "{stationCode} · {workOrderNo} {slaLabel} aşıldı",
        messageTemplate: "{workOrderTitle} — son an {dueAt}, öncelik {priorityLabel}.",
    },
    CORRECTIVE_ACTION_DUE: {
        code: "CORRECTIVE_ACTION_DUE",
        category: "COMPLIANCE",
        label: "Denetim düzeltici faaliyeti son tarihi",
        description: "Denetim ziyaretinin düzeltici faaliyetinin son tarihi yaklaşıyor; geçtiyse kritik. Faaliyet kapanınca çözülür.",
        defaultSeverity: "IMPORTANT",
        severities: ["IMPORTANT", "CRITICAL"],
        source: "CHECK",
        events: [],
        resolveEvents: [],
        resolvedByCheck: true,
        permission: "compliance.read",
        defaultRoles: [...STATION_OPS, "ADMIN"],
        escalationMinutes: null,
        thresholds: { warningDays: 7 },
        dedupPattern: "CORRECTIVE_ACTION_DUE:action:{actionId}:{dueDate}",
        link: "/uyum/denetimler/{inspectionId}",
        titleTemplate: "{stationCode} · düzeltici faaliyet {dueLabel}",
        messageTemplate: "{actionDescription} — son tarih {dueDate} ({authorityLabel} denetimi).",
    },
};
export const ALARM_RULE_LIST = ALARM_RULE_CODES.map((code) => ALARM_RULES[code]);
/** Alarm motorunun dinlediği olay tipleri (açan + çözen), tekil ve sıralı. */
export const ALARM_SOURCE_EVENT_TYPES = [
    ...new Set(ALARM_RULE_LIST.flatMap((rule) => [...rule.events, ...rule.resolveEvents])),
].sort();
/** Yükseltme halkaları: 0 = kuralın rolleri; 1 = bölge müdürü; 2 = yönetici + sahip (en üst). */
export const ALARM_ESCALATION_RING_ROLES = [
    [],
    ["REGION_MANAGER"],
    ["ADMIN", "OWNER"],
];
//# sourceMappingURL=catalog.js.map